export * from './getCategoriesText'
export * from './getRegionsText'
export * from './getViewCount'
